import { useEffect } from 'react';

const SITE_URL = process.env.REACT_APP_SITE_URL || 'https://eziblankusa.com';
const DEFAULT_IMAGE = `${SITE_URL}/EZI_hero3.png`;

const setMeta = (selector, attributes) => {
  let element = document.head.querySelector(selector);
  if (!element) {
    element = document.createElement('meta');
    Object.entries(attributes.match || {}).forEach(([key, value]) => element.setAttribute(key, value));
    document.head.appendChild(element);
  }
  Object.entries(attributes.value || {}).forEach(([key, value]) => element.setAttribute(key, value));
};

const setLink = (rel, href) => {
  let element = document.head.querySelector(`link[rel="${rel}"]`);
  if (!element) {
    element = document.createElement('link');
    element.setAttribute('rel', rel);
    document.head.appendChild(element);
  }
  element.setAttribute('href', href);
};

const setJsonLd = (data) => {
  const id = 'page-json-ld';
  let element = document.getElementById(id);
  if (!data) {
    if (element) element.remove();
    return;
  }
  if (!element) {
    element = document.createElement('script');
    element.id = id;
    element.type = 'application/ld+json';
    document.head.appendChild(element);
  }
  element.textContent = JSON.stringify(data);
};

const SEO = ({
  title = 'Server Rack Blanking Panels and Data Center Airflow Products | EZIBLANK USA',
  description = 'Shop EziBlank server rack blanking panels, brush panels, EziWall airflow barriers, and rack airflow management products for data centers and network rooms.',
  path = '/',
  image = DEFAULT_IMAGE,
  jsonLd,
}) => {
  useEffect(() => {
    const canonical = `${SITE_URL}${path}`;
    document.title = title;

    setMeta('meta[name="description"]', {
      match: { name: 'description' },
      value: { content: description },
    });
    setMeta('meta[name="robots"]', {
      match: { name: 'robots' },
      value: { content: 'index, follow, max-image-preview:large' },
    });
    setMeta('meta[property="og:title"]', {
      match: { property: 'og:title' },
      value: { content: title },
    });
    setMeta('meta[property="og:description"]', {
      match: { property: 'og:description' },
      value: { content: description },
    });
    setMeta('meta[property="og:url"]', {
      match: { property: 'og:url' },
      value: { content: canonical },
    });
    setMeta('meta[property="og:image"]', {
      match: { property: 'og:image' },
      value: { content: image },
    });
    setMeta('meta[name="twitter:title"]', {
      match: { name: 'twitter:title' },
      value: { content: title },
    });
    setMeta('meta[name="twitter:description"]', {
      match: { name: 'twitter:description' },
      value: { content: description },
    });
    setMeta('meta[name="twitter:image"]', {
      match: { name: 'twitter:image' },
      value: { content: image },
    });
    setLink('canonical', canonical);
    setJsonLd(jsonLd);
  }, [title, description, path, image, jsonLd]);

  return null;
};

export { SITE_URL };
export default SEO;
